import * as tslib_1 from "tslib";
import React from 'react';
import TextInput from 'sinoui-components/TextInput';
var ESC_KEY_CODE = 27;
var ENTER_KEY_CODE = 13;
/**
 * 拥有高级特性的输入框组件
 *
 * @export
 * @class AdvancedTextInput
 * @extends {React.PureComponent<Props, State>}
 */
var AdvancedTextInput = /** @class */ (function (_super) {
    tslib_1.__extends(AdvancedTextInput, _super);
    function AdvancedTextInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textInputRef = React.createRef();
        _this.state = {
            value: '',
        };
        /**
         * 监听输入框值变更事件的监听器
         *
         * @memberof AdvancedTextInput
         */
        _this.onChange = function (event) {
            var value = _this.getValueFromEvent(event);
            _this.setState({
                value: value,
            });
            if (_this.props.onInputValueChange) {
                _this.props.onInputValueChange(event);
            }
        };
        /**
         * 监听失去焦点事件的监听器
         *
         * @memberof AdvancedTextInput
         */
        _this.onBlur = function (event) {
            var _a = _this.props, onChange = _a.onChange, onBlur = _a.onBlur;
            if (_this.props.onNativeBlur) {
                _this.props.onNativeBlur(event);
            }
            if (onChange) {
                var value = _this.getValueFromEvent(event);
                onChange(value);
            }
            event.persist();
            setTimeout(function () {
                if (onBlur) {
                    onBlur(event);
                }
            }, 100);
        };
        /**
         * 监听按键事件的监听器
         *
         * @memberof AdvancedTextInput
         */
        _this.onKeyDown = function (event) {
            var keyCode = event.keyCode;
            var _a = _this.props, onChange = _a.onChange, blurAfterEnter = _a.blurAfterEnter, onKeyDown = _a.onKeyDown;
            if (keyCode === ESC_KEY_CODE) {
                _this.setState({
                    value: _this.props.value || '',
                });
                _this.textInputRef.current.blur();
            }
            if (keyCode === ENTER_KEY_CODE) {
                if (blurAfterEnter) {
                    _this.textInputRef.current.blur();
                }
                else if (onChange) {
                    onChange(_this.state.value);
                }
            }
            if (onKeyDown) {
                onKeyDown(event);
            }
        };
        return _this;
    }
    AdvancedTextInput.prototype.componentDidMount = function () {
        if (this.props.inputRef) {
            this.props.inputRef(this.textInputRef.current);
        }
    };
    AdvancedTextInput.prototype.componentWillUnmount = function () {
        if (this.props.inputRef) {
            this.props.inputRef(null);
        }
    };
    /**
     * 从组件属性中同步value到组件状态中
     *
     * @static
     * @param {Props} nextProps
     * @param {State} prevState
     * @returns
     * @memberof AdvancedTextInput
     */
    AdvancedTextInput.getDerivedStateFromProps = function (nextProps, prevState) {
        if (prevState.valueFromProps !== nextProps.value) {
            return {
                valueFromProps: nextProps.value,
                value: nextProps.value || '',
            };
        }
        return null;
    };
    AdvancedTextInput.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return (!shallowEqual(this.props, nextProps, [
            'value',
            'disabled',
            'readOnly',
            'readonly',
            'id',
            'name',
            'error',
        ]) || !shallowEqual(this.state, nextState));
    };
    AdvancedTextInput.prototype.getValueFromEvent = function (event) {
        var value = event.target.value;
        if (this.props.onBeforeChange) {
            value = this.props.onBeforeChange(value);
        }
        return value;
    };
    AdvancedTextInput.prototype.render = function () {
        var _a = this.props, onChange = _a.onChange, value = _a.value, onInputValueChange = _a.onInputValueChange, onBlur = _a.onBlur, onFocus = _a.onFocus, onKeyDown = _a.onKeyDown, blurAfterEnter = _a.blurAfterEnter, showValueInTitle = _a.showValueInTitle, rest = tslib_1.__rest(_a, ["onChange", "value", "onInputValueChange", "onBlur", "onFocus", "onKeyDown", "blurAfterEnter", "showValueInTitle"]);
        return (React.createElement(TextInput, tslib_1.__assign({}, rest, { autoComplete: "off", title: showValueInTitle ? value : '', inputRef: this.textInputRef, value: this.state.value, onChange: this.onChange, onBlur: this.onBlur, onFocus: this.props.onFocus, onKeyDown: this.onKeyDown })));
    };
    return AdvancedTextInput;
}(React.Component));
export default AdvancedTextInput;
var sameValueZeroEqual = function (objectA, objectB) {
    return objectA === objectB || (objectA !== objectA && objectB !== objectB);
};
/**
 * 浅层比较
 *
 * @export
 * @template T
 * @param {T} objectA
 * @param {T} objectB
 * @returns
 */
function shallowEqual(objectA, objectB, includeProperties) {
    if (sameValueZeroEqual(objectA, objectB)) {
        return true;
    }
    if (objectA && objectB) {
        var keysA = Object.keys(objectA);
        var keysB = Object.keys(objectB);
        if (keysA.length !== keysB.length) {
            return false;
        }
        var needPickProperties = !!includeProperties && includeProperties.length > 0;
        for (var i = keysA.length; i--;) {
            var key = keysA[i];
            if ((!needPickProperties || includeProperties.indexOf(key) !== -1) &&
                (keysB.indexOf(key) === -1 || objectA[key] !== objectB[key])) {
                return false;
            }
        }
        return true;
    }
    return false;
}
//# sourceMappingURL=AdvancedTextInput.js.map